<template>
  <div>
    <div class="container flash-message-top-container">
      <flash-message class="flash-message-top"></flash-message>
    </div>
    <div class="container container-admin text-center">
    <h3>{{title}}</h3>

    <div class="row">
      <div class="col-md-6 label-left">
        <label class="requered" for="title">Image Title</label>
        <input type="text" class="form-control" id="title" v-validate="'required'" name="title" aria-describedby="imageTitle" placeholder="Image Title" v-model="imageTitle">
        <br>
        <label class="requered" for="image">Image</label>
        <input type="file" accept="image/*" class="form-control" id="image" v-validate="'required'" name="title" aria-describedby="imagePath" placeholder="Image Path"  @change="onChangeFile($event)">
       <br>
        <label class="requered" for="mediaPlaceImage">image place on page</label>
        <select v-model="place" class="form-control" id="mediaPlaceImage" name="mediaPlaceImage" aria-describedby="mediaPlaceImage">
          <option value="gallery_image" selected>gallery image</option>
          <option value="home_image_slider">home image slider</option>
        </select>
        <br>
       <a href="#" class="btn btn-primary" @click="imageHandler($event)">Add image</a>
      </div>
      <div class="col-md-6 label-left">
        <label class="requered" for="videotitle">Video Title</label>
        <input type="text" class="form-control" id="videotitle" v-validate="'required'" name="title" aria-describedby="videoTitle" placeholder="Video Title" v-model="Video.title">
        <br>
        <label class="requered" for="videolink">Video Link</label>
        <input type="text"  class="form-control" id="videolink" v-validate="'required'" name="videolink" aria-describedby="videolink" placeholder="Video Link" v-model="Video.link">
        <br>
        <label class="requered" for="mediaPlaceVideo">video place on page</label>
        <select v-model="Video.place" class="form-control" id="mediaPlaceVideo" name="mediaPlaceVideo" aria-describedby="mediaPlaceVideo">
          <option value="home_video_slider">Home video slider</option>          
        </select>
        
        <br>
        <a href="#" class="btn btn-primary" @click="videoHandler($event)">Add video</a>
      </div>
    </div>

    
    <div class="div-separator"></div>
    <div class="row">
        <div class="col-md-6">
          <h4>gallery</h4>
          <div class="col-md-6" v-for="imgObj in this.listGallery" v-bind:key="imgObj._id">
            <div class="card">
              <img :src="'/image/gallery/' + imgObj.link" class="card-img-top" :alt="imgObj.title">
              <div class="card-body">
                <a href="#" class="btn btn-primary" @click="deleteHandler(imgObj._id,'image')">Delete</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <h4>video</h4>
          <div class="col-md-12" v-for="videoObj in this.listVideo" v-bind:key="videoObj._id">
            <div class="card">
              
              <iframe width="100%" height="260" :src="videoObj.link" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <div class="card-body">
                
                <a href="#" class="btn btn-primary" @click="deleteHandler(videoObj._id,'video')">Delete</a>
              </div>
            </div>
          </div>
        </div>
    </div>
   </div>
  </div>
</template>

<script>
  import { getDataFromServerWithHeader, getDataFromServer } from '../../utils/DataProvider';
  export default {
    data: () => {
      return{
         title: 'Gallery',
         imageTitle:'',
         image: '',
         place:'',
         listGallery: [], 
         listVideo:[],
         Video: {title:'',link:'', media_type:'video', place:''}          
      }     
    },
    methods:{
      onChangeFile(e){
        console.log("onChangeFile")
        this.image = event.target.files[0]
      },

      imageHandler(e){ 
        e.preventDefault();       
        let data = new FormData();
        data.append('picture', this.image);
        data.append('title', this.imageTitle);
        data.append('place', this.place);
        getDataFromServerWithHeader('add_gallery', data, { 'Content-Type': 'multipart/form-data' })
        .then(obj => {        
                if(obj.data.success === true){
                  this.flash('add image success ' , 'success', {timeout: 4000})
                  this.getGalleryList()
                }
                else{
                  this.flash('add image error: ' + obj.data.text , 'error', {timeout: 4000})
                }            
        })
        .catch(err => {            
            this.flash('add image error: ' + err, 'error', {timeout: 4000})           
        });
      },

    videoHandler(e){
      let videoLink=this.Video.link;
      let videoLinkToSave;
      if(videoLink.indexOf('embed') === -1){
          let videoLinkParts = videoLink.split('/');
          if(videoLinkParts.length > 0){
              let lastVideoLinkPart = videoLinkParts[videoLinkParts.length -1];
              if(lastVideoLinkPart.indexOf('watch?') !== -1){
                  let videoId = lastVideoLinkPart.split('=')[1];
                  videoLinkToSave = "https://www.youtube.com/embed/" + videoId;
              }else{
                  videoLinkToSave = "https://www.youtube.com/embed/" + lastVideoLinkPart;
              }
          }
        }
      this.Video.link=videoLinkToSave
      getDataFromServer('add_video', this.Video)
        .then(obj => 
        {
          console.log("response success : ", obj.data.success);
          if(obj.data.success === true){
            console.log("response add video: ", obj.data.data);              
            this.getVideoList();          
          }
          else{
            this.flash(' add video error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {
          console.log("response : ", err);
           this.flash(' add video error: ' + err, 'error', {timeout: 4000})
        })
    },
    
      getGalleryList(){
        getDataFromServer('list_gallery', {mediatype:'image'})
        .then(obj => 
        {
          console.log("response success : ", obj.data.success);
          if(obj.data.success === true){
            console.log("response list_gallery: ", obj.data.data);              
            this.listGallery = obj.data.data;          
          }
          else{
            this.flash('get gallery error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {
          console.log("response : ", err);
           this.flash('get gallery error: ' + err, 'error', {timeout: 4000})
        })
      },

      getVideoList(){
        getDataFromServer('list_gallery', {mediatype:'video'})
        .then(obj => 
        {
          console.log("response success : ", obj.data.success);
          if(obj.data.success === true){
            console.log("response list_gallery: ", obj.data.data);              
            this.listVideo = obj.data.data;          
          }
          else{
            this.flash('get gallery error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {
          console.log("response : ", err);
           this.flash('get gallery error: ' + err, 'error', {timeout: 4000})
        })
      },

      deleteHandler(imageId,mediaype){
        getDataFromServer('delete_gallery', {id: imageId})
        .then(obj => 
        {          
          if(obj.data.success === true){                          
             this.flash('delete ' + mediaype + ' success ' , 'success', {timeout: 4000})
             if(mediaype == 'image')
              this.getGalleryList()
             if(mediaype == 'video')
              this.getVideoList()
          }
          else{
            this.flash('delete ' + mediaype + ' error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {          
           this.flash('delete ' + mediaype + ' error: ' + err, 'error', {timeout: 4000})
        })
      }
    },

    created(){
      this.getGalleryList();
      this.getVideoList();
    }
  }
</script>

<style scoped>

  .div-image-add{
    margin-top: 10px;
    text-align: left;
  }

  .div-image-add a{
    margin-left: 15px;
  }

  .card{
    min-height: 260px;
    display: flex;
    flex-direction: column;
    border: solid 1px #ccc;
    margin-top: 20px;
  }

  .card img{
    width: 250px;
    max-height: 260px;
  }

  .card-body{
    margin-top: 5px;
    flex-grow: 1;    
    bottom: 0;
    position: absolute;
    padding: 10px;
  }

  .div-separator{
    margin-top: 40px;
    margin-bottom: 20px;
    height: 1px;
    background-color: #ccc;
    width: 100%;
  }

</style>
